export default "__VITE_ASSET__2847b342__"